// --- Main Component ---
import { Button, Card, Flex, Text, TextField } from "@engaging-tech/components"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

import codeCheckContainer from "../../containers/codeCheck.container"
import SurveyLogo from "../surveyLogo"

const hasValidLength = textCode => textCode.length > 2

const CodeCheckContent = ({
  individualCode,
  surveyId,
  checkCode,
  setCode,
  onNext,
  onPrevious,
  requireApiValidation,
  status,
  surveyType
}) => {
  const [textCode, onTextCodeChange] = useState(individualCode)
  const [error, setError] = useState(false)
  const { t } = useTranslation(["organisation_survey"])

  useEffect(() => {
    if (status === "draft" || status === "scheduled") {
      onNext()
    }
  }, [onNext, status])

  const handleSubmit = () => {
    if (!hasValidLength(textCode)) {
      setError(true)
      return
    }
    setCode(textCode)

    if (requireApiValidation) checkCode({ code: textCode, surveyId })
    else onNext()
  }
  return (
    <Card bg="light.0" mt={[5, 5, 6]} mb={[6, 5]} elevation={8} px={4}>
      <Flex flexDirection="column" py={3} px={[3, 4]} alignContent="center">
        <SurveyLogo />
        <Text color="dark.1" fontSize={4} textAlign="center" my={3} fontWeight={500}>
          {t("code_check.text1", "")}
        </Text>

        <TextField
          data-testid="code-input"
          value={textCode || ""}
          style={{ fontWeight: 700 }}
          onChange={e => onTextCodeChange(e.target.value)}
          width={1 / 1}
          error={error && "Value must be at least 3 characters."}
          placeholder={t("code_check.enter_code", "")}
        />

        <Text color="dark.1" fontSize={4} fontWeight={500}>
          {surveyType === "organisation" ? (
            <>
              {t("code_check.text2")} <a href="mailto:support@workl.com">support@workl.com</a>
            </>
          ) : (
            t("code_check.text3", "")
          )}
        </Text>
      </Flex>

      <Flex flexDirection="row" py={2} px={[3, 4]} justifyContent="space-between">
        <Button data-testid="code-cancel-btn" variant="text.dark.1" elevation={0} onClick={onPrevious} my={2} mx={[3, 4]}>
          {t("code_check.cancel", "")}
        </Button>
        <Button data-testid="code-submit-btn" my={2} variant="primary.0" onClick={handleSubmit}>
          {t("code_check.submit", "")}
        </Button>
      </Flex>
    </Card>
  )
}

export default codeCheckContainer(CodeCheckContent)
